var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationService } from '../../services/communication.service';
import { LoginService } from '../../services/login.service';
import { MyRemaxModes } from '../../classes/enums';
import { HasSubscriptions } from '../has-subscriptions';
var SideNavComponent = /** @class */ (function (_super) {
    __extends(SideNavComponent, _super);
    function SideNavComponent(router, communicationService, _loginService) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.communicationService = communicationService;
        _this._loginService = _loginService;
        _this.showLeftNav = false;
        _this.showRightNav = false;
        _this.changeRoute = new EventEmitter();
        return _this;
    }
    SideNavComponent.prototype.ngOnInit = function () { };
    SideNavComponent.prototype.logout = function () {
        this.communicationService.navigation.toggleNavs.next({ left: false, right: false });
        this.addSub(this._loginService.logout()
            .subscribe(function (r) {
            // Do nothing, fire and forget
        }));
        var queryIndex = this.router.url.indexOf('?');
        var url = queryIndex === -1 ? this.router.url : this.router.url.substring(0, queryIndex);
        this.router.navigate([url]);
    };
    SideNavComponent.prototype.toSavedSearches = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showRightNav = false;
                        return [4 /*yield*/, this.router.navigate(['/my-remax'], { queryParams: { mode: MyRemaxModes.SAVED_SEARCHES } })];
                    case 1:
                        _a.sent();
                        this.changeRoute.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    SideNavComponent.prototype.toFavourites = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showRightNav = false;
                        return [4 /*yield*/, this.router.navigate(['/my-remax'], { queryParams: { mode: MyRemaxModes.FAVOURITES } })];
                    case 1:
                        _a.sent();
                        this.changeRoute.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    SideNavComponent.prototype.toMyAccount = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showRightNav = false;
                        return [4 /*yield*/, this.router.navigate(['/my-account'])];
                    case 1:
                        _a.sent();
                        this.changeRoute.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    SideNavComponent.prototype.openSignIn = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.communicationService.showSignIn.next(true);
                return [2 /*return*/];
            });
        });
    };
    SideNavComponent.prototype.toFavouriteAgent = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showRightNav = false;
                        return [4 /*yield*/, this.router.navigate([$event])];
                    case 1:
                        _a.sent();
                        this.changeRoute.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    SideNavComponent.prototype.closeLeftNav = function () {
        this.showLeftNav = false;
        this.communicationService.navigation.toggleNavs.next({ left: false, right: false });
    };
    SideNavComponent.prototype.closeRightNav = function () {
        this.showRightNav = false;
        this.communicationService.navigation.toggleNavs.next({ left: false, right: false });
    };
    return SideNavComponent;
}(HasSubscriptions));
export { SideNavComponent };
